import { render, staticRenderFns } from "./InscribirView.vue?vue&type=template&id=12ab968c&scoped=true"
import script from "./InscribirView.vue?vue&type=script&lang=js"
export * from "./InscribirView.vue?vue&type=script&lang=js"
import style0 from "./InscribirView.vue?vue&type=style&index=0&id=12ab968c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ab968c",
  null
  
)

export default component.exports